import {
    AdsenseCell,
    ChangePercentage,
    GroupTrafficShare,
    IndexCell,
    RankCell,
    TrafficShare,
    WebsiteTooltipTopCell,
} from "app/components/React/Table/cells";
import { StyledCellCategory } from "app/pages/website-analysis/traffic-sources/display-ads/publishers/common/StyledComponents";
import { LinkCell } from "pro-features/components/Workspace/TableCells/LinkCell";
import { i18nFilter } from "app/filters/i18nFilter";
import { DefaultCellHeaderRightAlign } from "app/components/React/Table/headerCells";

const i18n = i18nFilter();
export const getCommonColumns = (getLinkForCategory, handleOpenQualificationSideBar) => [
    {
        fixed: true,
        cellComponent: IndexCell,
        disableHeaderCellHover: true,
        sortable: false,
        width: 46,
        isResizable: false,
    },
    {
        field: "Domain",
        displayName: i18n("analysis.destination.ad.websites.table.columns.domain.title"),
        tooltip: i18n("analysis.destination.ad.websites.table.columns.domain.title.tooltip"),
        cellComponent: (props) => {
            return (
                <WebsiteTooltipTopCell
                    {...props}
                    handleOpenQualificationSideBar={handleOpenQualificationSideBar}
                />
            );
        },
        sortable: true,
        fixed: true,
        showTotalCount: true,
        width: 250,
    },
    {
        field: "Category",
        displayName: i18n("analysis.destination.ad.websites.table.columns.category.title"),
        tooltip: i18n("analysis.destination.ad.websites.table.columns.category.title.tooltip"),
        cellComponent: (props) => {
            const { value, row } = props;
            if (!value || value === "null") {
                return <div>N/A</div>;
            } else if (value.trim() === "Unknown") {
                return <div>{value}</div>;
            } else {
                return (
                    <StyledCellCategory>
                        <LinkCell
                            href={getLinkForCategory("industry", row.CategoryApi)}
                            value={value}
                            title={value}
                        />
                    </StyledCellCategory>
                );
            }
        },
        sortable: true,
        minWidth: 180,
        maxWidth: 380,
    },
];

export const getSingleColumns = (durationTooltipParams) => [
    {
        field: "Rank",
        displayName: i18n("analysis.destination.ad.websites.table.columns.rank.title"),
        tooltip: i18n("analysis.destination.ad.websites.table.columns.rank.title.tooltip"),
        cellComponent: RankCell,
        headerComponent: DefaultCellHeaderRightAlign,
        format: "rank",
        sortable: true,
        minWidth: 100,
        maxWidth: 180,
    },
    {
        field: "Share",
        displayName: i18n("analysis.destination.paidout.trafficShare"),
        tooltip: i18n("analysis.destination.paidout.trafficShare.tooltip"),
        cellComponent: TrafficShare,
        sortable: true,
        minWidth: 130,
        maxWidth: 250,
    },
    {
        field: "Change",
        displayName: i18n("analysis.source.ad.websites.table.columns.change.title"),
        tooltip: i18n("analysis.source.ad.websites.table.columns.change.title.tooltip", durationTooltipParams),
        cellComponent: ChangePercentage,
        headerComponent: DefaultCellHeaderRightAlign,
        sortable: true,
        minWidth: 95,
        maxWidth: 140,
    },
    {
        field: "HasAdsense",
        displayName: i18n("analysis.all.table.columns.googleAds.title"),
        tooltip: i18n("analysis.all.table.columns.googleAds.title.tooltip"),
        cellComponent: AdsenseCell,
        sortable: true,
        width: 70,
    },
];

export const getCompareColumns = () => [
    {
        field: "TotalShare",
        displayName: i18n("analysis.search.advertisers.table.columns.totalShareCompare.title"),
        tooltip: i18n("analysis.search.advertisers.table.columns.totalShareCompare.title.tooltip"),
        cellComponent: TrafficShare,
        sortable: true,
        minWidth: 150,
    },
    {
        field: "SiteOrigins",
        displayName: i18n("analysis.search.advertisers.table.columns.shareCompare.title"),
        tooltip: i18n("analysis.search.advertisers.table.columns.shareCompare.title.tooltip"),
        cellComponent: GroupTrafficShare,
        minWidth: 250,
    },
];
